<template>
  <CockpitDialog
    title="安全岛"
    left="630px"
    width="690px"
    height="250px"
    top="120px"
    @close="$emit('close')"
  >
    <div class="w-full h-full" v-loading="loading">
      <el-row :gutter="15" class="w-full h-full overflow-auto">
        <el-col v-for="(item, index) in formConfig" :key="index" :span="8">
          <div class="h-30px leading-30px flex justify-start items-center">
            <div class="inline-block w-100px">{{ item.label }}：</div>
            <el-tooltip :content="item.value + ''">
              <div class="inline-block flex-1 truncate">
                {{ item.value }}
              </div>
            </el-tooltip>
          </div>
        </el-col>
      </el-row>
    </div>
  </CockpitDialog>
</template>

<script>
import dayjs from 'dayjs'
import { EvacuateSafetyIslandApi } from '@wiz-api/emergency-management'
import { ModelSceneApi } from '@wiz-api/scene-management'
import CockpitDialog from '@/components/cockpit/CockpitDialog'

const modelSceneApi = new ModelSceneApi()
const evacuateSafetyIslandApi = new EvacuateSafetyIslandApi()

export default {
  name: 'escape-route-dialog',
  data() {
    return {
      loading: false,
      formConfig: [
        {
          label: '安全岛名称',
          field: 'name',
          value: '',
        },
        {
          label: '安全岛编码',
          field: 'codeStr',
          value: '',
        },
        {
          label: '安全岛高度',
          field: 'height',
          value: '',
        },
        {
          label: '所属场景',
          field: 'sceneId',
          value: '',
        },
        {
          label: '安全岛坐标',
          field: 'coordinateJson',
          value: '',
        },
      ],
    }
  },
  components: {
    CockpitDialog,
  },
  props: {
    propData: {
      type: Object,
      defalut: () => {},
    },
  },
  watch: {
    propData: {
      handler(newVal) {
        this.getDetail(newVal.id, newVal.sceneId)
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    /**
     * 获取详情
     * @param { 主键id } id
     * @param { 场景id } sceneId
     */
    async getDetail(id, sceneId) {
      this.loading = true
      const [err, res] = await evacuateSafetyIslandApi.get(id, { id })
      if (!err) {
        this.formConfig.forEach(async (item) => {
          const keys = Object.keys(res)
          if (keys.includes(item.field)) {
            if (item.field === 'sceneId') {
              item.value = await this.getSceneDetail(sceneId)
            } else if (item.field === 'coordinateJson') {
              const coordinateJson = JSON.parse(res.coordinateJson)
              coordinateJson.forEach((ele) => {
                item.value += `(${ele.xIndex}, ${ele.yIndex}, ${ele.zIndex}) `
              })
            } else {
              item.value = res[item.field]
            }
          }
        })
      }
      this.loading = false
    },

    /**
     * 获取场景列表
     */
    async getSceneDetail(id) {
      let sceneName = ''
      const [err, res] = await modelSceneApi.get(id, { id })
      if (!err) {
        sceneName = res.name
      }
      return sceneName
    },
  },
}
</script>

<style scoped lang="scss"></style>
